import { render, staticRenderFns } from "./DivDeletable.vue?vue&type=template&id=6df81db6&scoped=true&lang=pug&"
import script from "./DivDeletable.vue?vue&type=script&lang=ts&"
export * from "./DivDeletable.vue?vue&type=script&lang=ts&"
import style0 from "./DivDeletable.vue?vue&type=style&index=0&id=6df81db6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df81db6",
  null
  
)

export default component.exports